module.exports = __webpack_public_path__ + "img/re_new_create_img1.80a67c8d.png";